import { render } from "./ StorageAndReporting.vue?vue&type=template&id=5cc1c4fb&scoped=true"
import script from "./ StorageAndReporting.vue?vue&type=script&lang=js"
export * from "./ StorageAndReporting.vue?vue&type=script&lang=js"

import "./ StorageAndReporting.vue?vue&type=style&index=0&id=5cc1c4fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc1c4fb"]])

export default __exports__